import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({ ...props }) => {
  return (
    <Sonner
      position="top-center"
      richColors
      closeButton
      toastOptions={{
        classNames: {
          toast: "group toast bg-white text-gray-900 border border-gray-200 shadow-lg rounded-xl",
          description: "text-gray-500",
          actionButton: "bg-blue-600 text-white",
          cancelButton: "bg-gray-100 text-gray-600",
          success: "bg-green-50 border-green-200 text-green-800",
          error: "bg-red-50 border-red-200 text-red-800",
          warning: "bg-yellow-50 border-yellow-200 text-yellow-800",
          info: "bg-blue-50 border-blue-200 text-blue-800",
        },
        duration: 4000,
      }}
      {...props}
    />
  );
}

export { Toaster, toast }
